// 로그인(login)
export type LoginInfo = {
  login_id: string;
  login_pw: string;
  login_type: string;
  mobile_token: string;
  mobile_os: number;
  web_version: string;
};
export type LoginResponse = {
  site_id_list: number[]|null;
  user_id: number;
  user_role: string|null;
  access_token: string|null;
};
// SMS 인증번호
export type SmsAuthRequestType = {
  name: string;
  phone: string;
  login_id?: string;
  resident_number?: string;
  gender?: number;
  sms_type?: string; // SIGNUP
}

// 업장(site)
export type SiteInfo = {
  id: number;
  type: number;
  name: string;
  sido: string;
  sigungu: string;
  eupmyeondong: string;
  ri: string;
  phone: string;
  approval: number;
  fax: string;
  email: string;
  latitude: number;
  longitude: number;
  company_id: number;
  road_address: string;
  jibun_address: string;
  detail_address: string;
  road_name: string;
  road_building_number: string;
  jibun_building_number: string;
  zip_code: string;
  temp_phone: string;
  reg_date: string;
  update_date: string;
  approval_date: string;
  image_list: ImageListType[];
  domain_comment:string;
  full_domain:string; //풀 도메인
  main_domain:string; //메인 도메인
  sub_domain:string; //서브 도메인
  server_port:number; //서버 포트
  is_ddns:number; //ddns 등록 상태 0:미등록, 1:등록
  update_cycle_minute:number; //ddns 업데이트 주기
  check_in_start_time:string; // 평일 등교 시작 시간 yy:mm:dd
  check_in_end_time:string; // 평일 등교 종료 시간
  check_out_start_time:string; // 평일 하교 시작 시간
  check_out_end_time:string; // 평일 하교 종료 시간
  holiday_check_in_start_time:string; // 주말 등교 시작 시간 yy:mm:dd
  holiday_check_in_end_time:string; // 주말 등교 종료 시간
  holiday_check_out_start_time:string; // 주말 하교 시작 시간
  holiday_check_out_end_time:string; // 주말 하교 종료 시간
};
export type SitePostType = {
  company_id?: number;
  type?: number; // 업장 타입 (1:유치원, 2:학원, 3:기타)
  name: string;
  full_address?: string;
  detail_address?: string;
  phone?: string;
  fax?: string;
  email?: string;
  temp_phone?: string;
  approval?: number; // 승인여부 (0:승인 대기, 1:승인 완료, 2:승인 거절)
  base64_list?: string[]; // 이미지 Base64 데이터
  check_in_start_time?:string; //등교 시작 시간 yy:mm:dd
  check_in_end_time?:string; //등교 종료 시간
  check_out_start_time?:string; //하교 시작 시간
  check_out_end_time?: string; //하교 종료 시간
  holiday_check_in_start_time?:string; // 주말 등교 시작 시간 yy:mm:dd
  holiday_check_in_end_time?:string; // 주말 등교 종료 시간
  holiday_check_out_start_time?:string; // 주말 하교 시작 시간
  holiday_check_out_end_time?:string; // 주말 하교 종료 시간
};

export type DdnsRequestType = {
  is_ddns:number;
  domain:string;
  domain_comment:string;
  update_cycle_minute:number;
}

// 사용자(user)
export type UserInfo = {
  id: number;
  name: string; // 복호화필요
  email: string; // 복호화필요
  phone: string; // 복호화필요
  role: string;
  approval: number; // 0: 승인 대기, 1: 승인 완료, 2: 승인 거절
  login_id: string;
  temp_phone: string; // 복호화필요
  user_site_list: UserSiteInfo[];
  company_id: number;
  terms_agree: number; // 0: 미동의, 1: 동의
  unique_code: string; // 사용자 고유 코드 (단말기 사번)
  card_no: string;
  reg_date: string;
  update_date: null;
  approval_date: string;
  last_login_date: string;
  last_logout_date: string;
  mobile_os: number; // 0: WEB, 1: 안드로이드, 2: IOS
  mobile_token: string;
  push_agree: number; // 0: 미동의, 1: 동의
  is_delete: number; // 0: 미삭제, 1: 삭제
  image_list: UserImageType[]; // 사용자 이미지 리스트
  student_list: StudentInfo[]; // 자녀 학생 리스트(학부모만)
  class_name_list:string[];
  image_url: string; //display용 이미지 URL
  temp_class_name: string;
  temp_child_student?: TempChildStudent;
  resident_number: string;
  gender: number;
};

export type UserShortInfo = {
  id: number;
  name: string; // 복호화필요
  role: string;
  login_id: string;
  image_file_name: string;
  site_list: SiteShortInfo[];
}

export type SiteShortInfo = {
  id: number;
  name: string;
  class_list: ClassShortInfo[];
}

export type ClassShortInfo = {
  id: number;
  name: string;
  user_id: number;
}

export type TempChildStudent = {
  class_name: string;
  id: number;
  name: string;
}

export type UserSiteInfo = {
  site_id:number;
  approval:number;
  approval_date:string;
}
export type UserPostType = {
  user_site_list?: UserSiteRequestType[];
  name?: string; // 암호화 필요
  email?: string; // 암호화 필요
  phone?: string; // 암호화 필요
  resident_number?: string; // 주민번호 (yymmdd)
  gender?: number; // 성별 (남자:1,3,5,7 여자:2,4,6,8)
  role?: string; // 사용자 권한 (ROLE_DIRECTOR, ROLE_TEACHER, ROLE_PARENT만 유효)
  login_id?: string;
  login_pw?: string; // 암호화 필요
  temp_phone?: string; // 암호화 필요
  terms_agree?: number; // 0: 미동의, 1: 동의
  unique_code?: string; // 사용자 고유 코드 (단말기 사번)
  card_no?: string;
  class_id?: number; // ROLE_TEACHER(선생님)인 경우 유효, 이외 0으로 설정
  student_id?: number; // ROLE_PARENT(학부모)인 경우 유효, 이외 0으로 설정
  temp_mobile_os?: number; // 1: Android, 2: IOS (회원 가입시 승인 push발송을 위한 모바일 OS) (web은 해당 없음)
  temp_mobile_token?: string; // 회원 가입시 승인 push 발송을 위한 임시 토큰 (web은 해당 없음)
  base64_list: string[];
};

export type UserRequestType = {
  name: string; // 암호화 필요
  email?: string; // 암호화 필요
  phone: string; // 암호화 필요
  temp_phone?: string;  // 암호화 필요
  unique_code?: string; // 사용자 고유 코드 (단말기 사번)
  card_no?: string;
  base64_list: string[],
}

export type UserSiteRequestType = {
  site_id?:number;
  approval?:number; // 0: 승인 대기, 1: 승인 완료, 2: 승인 거절
}

// 반(class)
export type ClassInfo = {
  id: number;
  site_id: number;
  user_id: number; // 담임 선생님 ID, 0: 미지정
  user_name:string; // 담임 선생님 이름
  name: string; //반 이름
  title: string; //반 소개 타이틀
  color_type:ColorType; //반 색상 코드
  content: string; //반 소개 내용
  logo_type: number; //로고 캐릭터 유형 0:없음, 1~n : 로고 캐릭터 ID
  reg_date: string; //등록일시
  update_date?: string; //수정일시
  student_list: StudentInfo[]; //학생 리스트
};

// 반 등록/수정
export interface ClassRequestType {
  site_id:number; // 업장 ID
  user_id:number; // 담임 선생님 ID
  name:string; // 반 이름
  color_type:string; // 반 색상 코드
  logo_type:number; // 로고 캐릭터 유형 0:없음, 1~n : 로고 캐릭터 ID
  title:string; // 반 소개 타이틀
  content:string; // 반 소개 내용
  student_ids:number[]; // 학생 ID 리스트
}


// 학생(student)
/**
 * - gender (1 남자 2 여자)
 * - unique_code (고유코드(단말기 사번))
 * - birth_date (yyyy-MM-dd)
 */
export type StudentInfo = {
  id: number;
  name: string; // 복호화해야함
  gender: number;
  site_id: number;
  unique_code: string;
  card_no: string;
  birth_date: string;
  temp_guardian_name: string;
  temp_guardian_phone: string;
  temp_guardian_relation: string;
  image_list: StudentImageType[];
  parent_list: UserStudentInfo[];
  site_info: SiteInfo;
  class_list: ClassInfo[];
  is_delete:number; // 0: 미삭제, 1: 삭제
  image_url:string; //학생 이미지 URL
  sync_device_status:number; //단말기 동기화 상태 (0:미동기화, 1:동기화)
};
//학생 조회 시 부모 정보
export interface UserStudentInfo {
  user_id:number; // 부모 ID
  student_id:number; // 학생 ID
  user_name:string; // 복호화해야함
  student_name:string; // 복호화해야함
  relation:string; // 부모 <-> 학생 관계
}

/**
 * 엑셀 파일 업로드 시 학생 정보 (서버 요청 데이터 X)
 */
export interface ExcelStudentInfo {
  name:string; //학생 이름
  //gender:string; //남자, 여자
  birthDate:string; //yyyymmdd
  imageFile:any; //학생 이미지 파일
}

/**
 * 반 일괄 이동 엑셀 파일 업로드 시 학생 정보 (서버 요청 데이터 X)
 */
export interface ExcelMoveClassStudentInfo {
  name: string; //학생 이름
  id: number; // 학생 ID
  image_file: string; // 학생 이미지 파일
  origin_class_id: number; // 기존 반 ID
  origin_class_name: string; // 기존 반 이름
  new_class_id: number; // 이동 반 ID
  new_class_name: string; // 이동 반 이름
  parent_id: number; // 학부모 ID
  parent_name: string; // 학부모 이름
  // parent_phone: string; // 학부모 연락처
}

export interface UserImageType extends ImageListType{
    user_id:number;
}

export interface StudentImageType extends ImageListType{
    student_id:number;
}

export interface ImageListType{
    id:number;
    file_name:string;
    file_path:string;
    file_size:number;
    mime_type:string;
    is_main:number;
    reg_date:string;
}


export interface ClassAddStudentType {
  student_ids:number[];
}

/**
 * 학생 등록/수정 요청 데이터
 */
export interface StudentRequestType {
  site_id:number;
  name:string;
  gender: number; // 1 남자 2 여자
  parent_list: StudentParentType[];
  birth_date:string;
  unique_code:string;
  card_no:string;
  base64_list:string[];
  temp_guardian_name:string;
  temp_guardian_phone:string;
  temp_guardian_relation:string;
  class_id:number; //임시
}

export interface StudentParentType {
    user_id:number;
    relation:string;
}

// 알림장(notebook)
/**
 * - type (0:행사, 1:준비물, 2:수업, 3:생활, 4:기타)
 * - note_order (등록 순서)
 * - is_group (0:개별, 1:그룹)
 * - user_id (작성자ID)
 * - create_user_type (작성자 권한 구분 1: 선생님, 2: 학부모)
 * - note_date (알림장 날짜(yyyy-mm-dd))
 * - reg_date (작성일시)
 * -
 */
export type NotebookInfo = {
  id: number;
  type: number;
  title: string;
  content: string;
  site_id: number;
  note_order: number;
  is_group: number;
  user_id: number;
  user_name: string;
  create_user_class_name: string;
  create_user_type: number;
  like_count: number;
  note_date: string;
  reg_date: string;
  update_date?: string;
  file_list: [];
  student_info: StudentInfo;
  class_info: ClassInfo;
  comment_list: [];
  like_user_list: [];
};
/**
 * - type (0:행사, 1:준비물, 2:수업, 3:생활, 4:기타)
 * - user_id (작성자ID)
 * - class_id (알림을 보낼 학생 반ID)
 */
export type NotebookRequestType = {
  note_date: string;
  type: number;
  title: string;
  content: string;
  user_id: number;
  class_id: number;
  student_ids: number[];
  class_name: string;
  student_names: string[];
};
// 공지사항(notice)
export type NoticeInfo = {
  id: number;
  title: string;
  content: string;
  site_id: number;
  user_id: number; // 작성자ID
  like_count: number;
  reg_date: string; // 작성일시
  update_date?: string;
  file_list: [];
  class_list: ClassInfo[];
  comment_list: [];
  like_user_id_list: [];
};
export type NoticeWriteType = {
  title: string;
  content: string;
  user_id: number; // 작성자ID
  class_ids: number[]; // 공지를 보낼 반ID
  remove_file_id_list:number[]; // 삭제할 파일 ID
};
// 출석부(attendance)
/**
 * - status (0: 결석, 1: 출석, 2: 인정 결석, 3: 병결, 4: 사고, 5:조퇴)
 * - date (yyyy-mm-dd)
 * - user_id (자동 출결일 경우 0)
 * - checkin_time, checkout_time (hh:mm:ss)
 * - reg_date, update_date (yyyy-mm-dd hh:mm:ss)
 */
export type AttendanceInfo = {
  id: number;
  status: number;
  date: string;
  student_id: number;
  site_id: number;
  user_id: number;
  reason: string;
  memo: string;
  checkin_time: string;
  checkout_time: string;
  reg_date: string;
  update_date: string | null;
  [key: string]: any;
};

// 출석부 신규 API용 Type
export type AttendanceStudentAllInfo = {
  attendance_list: AttendanceOneInfo[];
  class_name: string;
  image_file_name: string;
  parent_name: string;
  site_id: number;
  student_birth_date: string;
  student_id: number;
  student_name: string;
};
export type AttendanceOneInfo = {
  site_id:number;
  id: number;
  status: number; //출결 상태 (0: 결석, 1: 출석, 2: 인정 결석, 3: 병결, 4: 사고, 5: 조퇴)
  date: string;
  day_type: string;
  is_data: number; // 출결 데이터 여부 (0: 미등록, 1: 등록)
  reason: string;
  memo: string;
  checkin_time: string;
  checkout_time: string;
  reg_date: string;
  update_date: string | null;
  user_id:number; //수동 등록한 경우 사용자 ID
  [key: string]: any;
};

export interface AttendanceRequestType {
  site_id:number; //업장 ID
  student_id:number; //학생 ID
  user_id:number; //수동 등록한 경우 사용자 ID
  status:number; //출결 상태 (0: 결석, 1: 출석, 2: 인정 결석, 3: 병결, 4: 사고, 5: 조퇴)
  reason:string; //사유
  memo:string; //메모
  checkin_time:string; //등교 시간
  checkout_time:string; //하교 시간
  date:string; //출결 날짜
}


export interface AttendanceCountQueryParams {
  class_id:number; //반 ID
  date:string; //yyyymmdd
}

export enum AttendanceDayType {
    WEEKDAY = "WEEKDAY", //평일
    WEEKEND = "WEEKEND", //주말
    HOLIDAY = "HOLIDAY", //공휴일
}

export interface AttendanceCountResponseType {
  day_type:AttendanceDayType; //출결 날짜 타입
  student_total_count:number; //총 학생 수
  attendance_count:number; //출석 수
  absence_count:number; //결석 수
  approved_absence_count:number; //인정 결석 수
  early_leave_count:number; //조퇴 수
  check_in_count:number; //등교 수
  check_out_count:number; //하교 수
}

// 수납(receipt, payment, discount)
/**
 * 수납정보
 * - type (1:원비, 2:준비물, 3:기타)
 * - payment_type (1:월납, 2:일시납)
 * - discount_status 할인 적용 유무 (0:사용 안함, 1:사용함)
 * + is_disabled (0:활성화, 1:비활성화)
 * + age_group 연령대 (0: 전체, 1: 0~3세, 2: 4~6세, 3: 7세 이상)
 */
export type PaymentInfo = {
  id: number;
  name: string;
  type: number;
  price: number;
  etc: string;
  site_id: number;
  payment_type: number;
  discount_status: number;
  is_disabled: number;
  age_group: number;
};
/**
 * 할인정보
 * - rate 할인율(%)
 * - max_price 최대 할인 금액(원)
 * - start_date 할인 시작 일시
 * + price 할인가
 * + discount_type 할인타입(할인율, 금액)
 */
export type DiscountInfo = {
  id: number;
  site_id: number;
  name: string;
  rate: number;
  price: number;
  discount_type: number;
  max_price: number;
  start_date: string;
  end_date: string;
  etc: string;
};

/**
 * 결제(청구서) 정보 - 등록시 간략한 정보
 * - user_id 사용자(결제자) ID
 * - pay_method 결제 수단 (1:카드, 2:현금, 3:계좌이체, 4:휴대폰, 5:기타)
 * - on_site_payment 현장 결제 여부 (0:현장 미결제, 1:현장 결제)
 * - bill_date 청구일(yyyy-mm-dd hh:mm:ss)
 * - clost_date 청구 마감일(yyyy-mm-dd hh:mm:ss)
 */
export type ReceiptInfo = {
  id: number;
  site_id: number;
  student_id: number;
  user_id: number;
  payment_info_id: number;
  discount_info_id: number | null;
  pay_method: number | null;
  on_site_payment: number | null;
  bill_date: string;
  close_date: string;
  etc: string;
};
/**
 * 결제(청구서) 정보 - 조회시 전체 정보
 * + receiptInfo 결제 간략 정보
 * - approval_number 카드 승인 번호
 * - send_status 청구서 전송 상태 (0:미전송, 1:전송완료)
 * - status 결제 상태
 *   (0:결제대기, 1:결제요청, 2:결제완료, 3:미납, 4:취소요청, 5:취소완료, 6:환불완료)
 */
export type ReceiptTotalInfo = {
  id: number;
  site_id: number;
  student_id: number;
  student_name: string;
  user_id: number;
  user_name?: string;
  payment_info_id: number;
  payment_info: PaymentInfo | undefined;
  discount_info_id: number | null;
  discount_info: DiscountInfo | undefined;
  pay_price: number;
  pay_date?: string;
  pay_method: number | null;
  on_site_payment: number | null;
  bill_date: string;
  close_date: string;
  cancel_date?: string;
  reg_date?: string;
  approval_number?: string;
  send_status: number;
  status: number;
  etc: string;
};

// select-option type
export type provinceInfo = {
  value: string | number;
  label: string;
};

// 내정보에서 비밀번호 변경
export type PasswordChangeType = {
  login_id: string;
  current_password: string;
  new_password: string;
  new_password_confirm: string;
}
// 비밀번호 찾기 후 비밀번호 변경
export type FindPasswordChangeType = {
  login_id: string;
  phone: string;
  new_password: string;
  new_password_confirm: string;
}


/**
 * 차량 정보 - 조회시 전체 정보
 * - plate_number 차량 번호
 * - vin_number 차대 번호
 * - device_id 단말기 ID
 * - last_latitude 마지막 위도
 * - last_longitude 마지막 경도
 */
export type BusInfo = {
  id: number;
  site_id: number;
  name: string;
  plate_number: string;
  vin_number: string;
  device_id: number;
  mdvr_ip: string;
  mdvr_port: number;
  mdvr_id: string;
  mdvr_pw: string;
  mdvr_p2p_uuid: string;
  last_latitude: string;
  last_longitude: string;
  reg_date: string;
}
// 차량 등록/수정
export type BusRequestType = {
  plate_number: string;
  vin_number: string;
  name: string;
  device_id: number;
  mdvr_ip: string;
  mdvr_port: number;
  mdvr_id: string;
  mdvr_pw: string;
  mdvr_p2p_uuid: string;
}

export interface DeviceInfo {
  id:number;
  site_id:number;
  name:string;
  product_code:number;
  ip_address:string;
  mac_address:string;
  serial_number:string;
  full_serial_number:string;
  model_name:string;
  auth_id:string;
  auth_pw:string;
  tcp_port:number;
  web_port:number;
  sdk_port:number;
  call_port:number;
  reg_date:string;
  update_date:string;
  connect_status:number;
  rtsp_url:string;
  call_status:number;
  last_connect_date:string;
  last_call_date:string;
}

export interface DeviceRequestType {
  site_id:number;
  name:string;
  ip_address:string;
  product_code:number; //1: hik, 2: heop
  auth_id:string;
  auth_pw:string;
  tcp_port:number;
  web_port:number;
  sdk_port:number;
  call_port:number;
}

//학생 동기화 시 요청 데이터
export interface SyncStudentDeviceRequestType{
  student_id_list:number[];
}

export enum ColorType {
  WHITE = "#FFFFFF",
  RED = "#E0062D",
  ORANGE = "#F49701",
  PINK = "#EC407A",
  YELLOW = "#FFC400",
  GREEN = "#1C7406",
  BLUE = "#2685F5",
  NAVY = "#1A237E",
  PURPLE = "#8D51F8",
  BLACK = "#000000",
}

export const defaultColor = "WHITE";
// Enum을 배열로 변환하여 키값과 색상 코드를 모두 사용
export const colorList = Object.entries(ColorType).map(([colorName, colorCode]) => ({
  colorName, // 키값 ("RED" 등)
  colorCode, // 색상 코드 ("#E0062D" 등)
}));

export interface UserQueryParams extends RequestQueryParams{
  site_id:number; //업장 ID
  name:string; //사용자 이름 검색어
  class_id:number; //반 ID
  role:string; //사용자 권한 (1:ROLE_DIRECTOR, 2:ROLE_TEACHER, 3:ROLE_PARENT)
  role_number: number; //사용자 권한 번호 (1:ROLE_DIRECTOR, 2:ROLE_TEACHER, 3:ROLE_PARENT)
  student_name: string;
}

export interface StudentQueryParams extends RequestQueryParams{
  user_id:number; //학부모 ID
  name:string; //학생 이름 검색어
  class_id:number; //반 ID
}

export interface ClassQueryParams extends RequestQueryParams {
  name:string; //반 이름 검색어
  response_format:string; // simple: 간략 정보
  user_id:number;//담당 선생님 ID
}

export interface BusQueryParams extends RequestQueryParams{
  name:string; //차량명
  plate_number:string; //차량 번호
}

//기본 request query params
export interface RequestQueryParams{
  page:number; // 페이지 번호
  size:number; // 가져올 데이터 수
}


// response
export interface CommonResult {
  code: number;
  message: string;
  type:string;
}
// SingleResult 모델 정의
export interface SingleResult<T> extends CommonResult {
  data: T;
}
// SingleResult 모델 정의
export interface SingleFiletResult<T> extends CommonResult {
  content_list: T;
}
// ListResult 모델 정의
export interface ListResult<T> extends CommonResult {
  data: T[];
  total_count: number;
}




export interface SignContextProps {
  signData: SignType,
  setSignData: React.Dispatch<React.SetStateAction<SignType>>;
}

export interface SiteListType {
  site_id: number,
  approval: number,
}
export interface SignType {
  user: {
      user_site_list: SiteListType[],
      name: string,
      email: string,
      phone: string,
      role: string,
      login_id: string,
      login_pw: string,
      temp_phone: string,
      terms_agree: number,
      unique_code: string,
      resident_number: string,
      gender: number,
      card_no: string,
      class_id: number,
      student_id: number,
      temp_mobile_os: number,
      temp_mobile_token: string,
      base64_list: string[],
  },
  site: {
      name: string,
      address: string,
      phone: string,
      fax: string,
      email: string,
  },
  site_id: number,
  class_id: number,
}
